function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10 21.813V29C9.99997 29.1769 10.0469 29.3507 10.1359 29.5036C10.225 29.6565 10.353 29.783 10.507 29.8702C10.6609 29.9575 10.8352 30.0023 11.0121 30.0001C11.1891 29.998 11.3622 29.9489 11.514 29.858L16 27.166L20.485 29.858C20.6368 29.9492 20.8101 29.9985 20.9872 30.0007C21.1642 30.003 21.3387 29.9582 21.4928 29.871C21.6469 29.7837 21.775 29.6571 21.8642 29.504C21.9533 29.351 22.0001 29.1771 22 29V21.813C20.1946 22.9195 18.1175 23.5035 16 23.5C13.801 23.5 11.747 22.883 10 21.813ZM22 20C20.2705 21.3011 18.1642 22.0032 16 22C13.6786 22.0034 11.4289 21.1955 9.64 19.716C8.50071 18.7788 7.58335 17.6008 6.95394 16.2666C6.32454 14.9324 5.99874 13.4752 6 12C6 6.477 10.477 2 16 2C21.523 2 26 6.477 26 12C26.0012 13.5527 25.6402 15.0842 24.9459 16.4729C24.2515 17.8617 23.2428 19.0693 22 20Z",
  fill: "#008C85"
});
var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 12,
  r: 8,
  fill: "white"
});
var _ref4 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2785_105164)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.2083 16.0832H11.8333C11.5902 16.0832 11.3571 15.9866 11.1851 15.8147C11.0132 15.6428 10.9167 15.4096 10.9167 15.1665V11.9582C10.9167 11.7151 11.0132 11.4819 11.1851 11.31C11.3571 11.1381 11.5902 11.0415 11.8333 11.0415H13.2083M16.4167 10.1248V8.2915C16.4167 7.92683 16.2718 7.57709 16.0139 7.31923C15.7561 7.06137 15.4063 6.9165 15.0417 6.9165L13.2083 11.0415V16.0832H18.3783C18.5994 16.0857 18.8139 16.0082 18.9824 15.865C19.1508 15.7218 19.2618 15.5226 19.295 15.304L19.9275 11.179C19.9474 11.0476 19.9386 10.9135 19.9015 10.7859C19.8645 10.6583 19.8001 10.5402 19.7129 10.4399C19.6257 10.3397 19.5178 10.2596 19.3965 10.2051C19.2753 10.1507 19.1437 10.1233 19.0108 10.1248H16.4167Z",
  stroke: "#008C85",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}));
var _ref5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2785_105164"
}, /*#__PURE__*/React.createElement("rect", {
  width: 11,
  height: 11,
  fill: "white",
  transform: "translate(10 6)"
})));
function SvgRibbonThumbGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRibbonThumbGreen);
export default __webpack_public_path__ + "static/media/ribbon-thumb_green.5acb5e49087e2c95a2e4ecb478218121.svg";
export { ForwardRef as ReactComponent };